import React from 'react';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { Services } from '../components/Services';
import { Comparison } from '../components/Comparison';
import { ProblemSolution } from '../components/ProblemSolution';
import { Process } from '../components/Process';
import { DoorGlass } from '../components/DoorGlass';
import { ShowerGlass } from '../components/ShowerGlass';
import { Mirrors } from '../components/Mirrors';
import { DeckScreens } from '../components/DeckScreens';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { ServiceArea } from '../components/ServiceArea';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
export function ResidentialGlass() {
  return <main className="w-full bg-white pb-20 lg:pb-0" data-id="element-235">
      <Hero data-id="element-236" />
      <TrustBar data-id="element-237" />
      <Services data-id="element-238" />
      <Comparison data-id="element-239" />
      <ProblemSolution data-id="element-240" />
      <Process data-id="element-241" />
      <DoorGlass data-id="element-242" />
      <ShowerGlass data-id="element-243" />
      <Mirrors data-id="element-244" />
      <DeckScreens data-id="element-245" />
      <WhyChooseUs data-id="element-246" />
      <ServiceArea data-id="element-247" />
      <FAQ data-id="element-248" />
      <FinalCTA data-id="element-249" />
      <StickyMobileCTA data-id="element-250" />
    </main>;
}